import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archive-payment',
  templateUrl: './archive-payment.component.html',
  styleUrls: ['./archive-payment.component.scss']
})
export class ArchivePaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
